module.exports = __webpack_public_path__ + "Montserrat-Medium.ttf";